<template>
  <div>
    <div class="card-input">
      <v-icon class="card-icon">mdi-credit-card-outline</v-icon>
    </div>
    <div class="payment-text" v-text="$t('checkout.fpDescription')" />
  </div>
</template>

<script>
export default {
  name: "CardProviderInfo",
};
</script>

<style lang="scss" scoped>
.card-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-input {
  border-radius: 5px;
  //background: linear-gradient(to bottom, var(--v-primary-base), #000000);
  //padding: 30px 15px 5px 15px; /* Adjusted padding */
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%; /* Ensure it scales responsively */
  max-width: 400px; /* Set a maximum width */
  justify-content: center;
  align-items: center;
}

.card-icon {
  font-size: 120px; /* Adjust the icon size as needed */
  color: #d9d5d5; /* Set the icon color */
}

.payment-text {
  margin-top: 10px; /* Adjust margin */
  text-align: center;
  color: #000000;
  font-size: 20px; /* Adjust font size */
  max-width: 400px; /* Ensure it scales responsively */
}
</style>
